module.exports = __webpack_public_path__ + "static/media/enterprenuarshipDark.d1e1d739.svg";